const $BASE_API = "https://bauenbackend.jeds.ar";
const $BASE_REST = "https://bauenbackend.jeds.ar/web";
// const $BASE_REST = "http://localhost/bauen_backend/web";
// const $BASE_REST = "http://192.168.0.174/bauen_backend/web";

export const environment = {
      production: false,
      jedstion: {
            // Se deja apuntando a produccion para la carga de tickets si hay modulos no subidos y se desea cargar un ticket.
            embedBaseUrl: 'https://gestion.projeds.com',
            useEmbedGateway: false,
            embedToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImtpZCI6ODd9.eyJzdWIiOjg3LCJpc3MiOiIiLCJhdWQiOiIiLCJpYXQiOjE3ODQ4MTA2NjgsImV4cCI6MjEzMjA1MjIwOCwianRpIjoiNGM4NGNiZmRiMDJiNjAyIiwibmljayI6ImplZHN0aW9uX2JhdWVuIiwiY29kaWdvIjo4NywiaWRlbXByZXNhIjozfQ.mWiebPuNFjaXYakhVj4rZqWywNAk8O-N65soTqljmHo'
      },
      baseApi: $BASE_API,
      baseRest: $BASE_REST,
      alertas: {
            view_alertas: `${$BASE_REST}/view_alertas`,
            alerta_usuario_marcar_leidas: `${$BASE_REST}/alerta_usuario/marcar_leidas`
      },
      login: {
            login: `${$BASE_REST}/usuario/login`,
            view_usuarios: `${$BASE_REST}/view_usuarios`,
            usuarios_login: `${$BASE_REST}/usuario/imagenes`
      },
      inicio: {
            view_complejos: `${$BASE_REST}/view_complejos?filter[cantidad_uf][gte]=1`,
            logo_complejos: `${$BASE_REST}`, // uploads/nombre_logo se lo concatena en home.component.ts
            view_unidad_funcionals: `${$BASE_REST}/view_unidad_funcionals?filter[complejo_id]=`
      },
      administracion: {
            contratos: {
                  view_contratos: `${$BASE_REST}/ctr_contrato?view=1`,
                  ctr_contratos: `${$BASE_REST}/ctr_contratos`,
                  cocheras_disponibles: `${$BASE_REST}/ctr_complejo/cocheras_disponibles`,
                  detalle_contrato: `${$BASE_REST}/ctr_contrato_detalle/generar`,
                  contrato_detalle_guardar: `${$BASE_REST}/ctr_contrato_detalle/guardar`,
                  cancelacion_anticipada: `${$BASE_REST}/ctr_contratos`,
                  generar_coutas: `${$BASE_REST}/ctr_contrato/generar_cuotas?idcontrato=`,
                  generar_cuotas_deposito: `${$BASE_REST}/ctr_contrato/generar_cuotas_deposito`,
                  generar_cuotas_comision: `${$BASE_REST}/ctr_contrato/generar_cuotas_comision`,
                  contrato_garantes: `${$BASE_REST}/ctr_contrato_garantes`,
                  contrato_garantes_cliente: `${$BASE_REST}/ctr_contrato_garante/por_cliente`
            },
            contratos_activos: {
                  contrato: `${$BASE_REST}/ctr_contrato`,
                  indice: `${$BASE_REST}/ctr_contrato/set_indices`,
                  alquiler: `${$BASE_REST}/ctr_contrato/actualizar_cuotas`,
                  adjunto: `${$BASE_REST}/ctr_contrato/cargar_adjunto`,
                  ver_adjunto: `${$BASE_REST}`, // uploads/nombre_pdf se lo concatena en adjunto.component.ts
                  aumento: `${$BASE_REST}/ctr_contrato/aumento`,
                  confirmar_expensa: `${$BASE_REST}/ctr_contrato/actualizar_expensas`,
                  ajuste_periodo: `${$BASE_REST}/ctr_contrato/actualizar_cuotas_actual`,
                  contrato_detalle: `${$BASE_REST}/ctr_contrato/detalle`,
                  renueva_contrato: `${$BASE_REST}/ctr_contratos`,
                  cancelacion_anticipada: `${$BASE_REST}/ctr_contratos`,
                  view_contrato_activos: `${$BASE_REST}/view_contrato_activos`,
            },
            indices: {
                  indice: `${$BASE_REST}/ctr_indice_valors`,
                  view_indice_valor: `${$BASE_REST}/view_indice_valors`,
            },
            expensas: {
                  expensa: `${$BASE_REST}/ctr_expensas`,
                  view_expensas: `${$BASE_REST}/view_expensas`,
                  view_expensa_comprobantes: `${$BASE_REST}/view_expensa_comprobantes`,
            },
            clientes: {
                  view_cliente: `${$BASE_REST}/view_cliente`,
                  clientes: `${$BASE_REST}/clientes`,
                  cuenta_corriente: `${$BASE_REST}/cuentacorriente`,
                  view_cliente_pagos: `${$BASE_REST}/view_cliente_pago`
            }
      },
      alquileres: {
            cuotas: {
                  view_punto_venta: `${$BASE_REST}/view_punto_venta`,
                  ventas_iva_honorarios: `${$BASE_REST}/venta/iva_honorarios`,
                  ventas: `${$BASE_REST}/ventas`,
                  // Comprobantes Asociados
                  view_comprobantes_asociados: `${$BASE_REST}/view_venta_comprobantes`,
                  tipos_comprobantes_habilitado: `${$BASE_REST}/factura/get_datos_comprobante`,
                  numero_comprobante: `${$BASE_REST}/factura/get_numero_comprobante`,
                  comprobante_factura: `${$BASE_REST}/facturas`,
                  reporte_comprobante: `${$BASE_REST}/factura/reporte_comprobante_pdf?id=`,
                  generar_comprobante: `${$BASE_REST}/factura/generar_comprobante?idfactura=`,
                  mail_reporte_comprobante: `${$BASE_REST}/factura/mail_reporte`,
                  previsualizar_mail_comprobante: `${$BASE_REST}/factura/previsualizar_mail`,
                  // Pagos Asociados
                  view_pagos_asociados: `${$BASE_REST}/view_venta_cobranza`,
                  // Pagares Asociados
                  view_pagares_asociados: `${$BASE_REST}/view_venta_pagare`,
                  // Pagos
                  view_cobranza_pendiente: `${$BASE_REST}/view_cobranza_pendiente`,
                  forma_pago_recargo_descuento: `${$BASE_REST}/forma_pago/recargo_descuento`,
                  forma_pago_calcular_intereses: `${$BASE_REST}/forma_pago/calcular_intereses`,
                  forma_pago: `${$BASE_REST}/forma_pagos`,
                  reporte_forma_pago: `${$BASE_REST}/forma_pago/reporte`,
                  mail_reporte_forma_pago: `${$BASE_REST}/forma_pago/mail_reporte`
            }
      },
      reportes: {
            reporte_compras: {
                  view_egreso_contable: `${$BASE_REST}/view_egreso_contable`,
                  view_reporte_impuesto_servicio: `${$BASE_REST}/view_reporte_impuesto_servicio`
            },
            reporte_caja: {
                  view_cobranza: `${$BASE_REST}/view_cobranza`,
                  datos_diarios: `${$BASE_REST}/reporte_caja/datos_diarios`,
                  generar_pdf: `${$BASE_REST}/reporte_caja/generar_pdf`
            },
            facturacion_punto_venta: {
                  view_venta_comprobantes: `${$BASE_REST}/view_venta_comprobantes`,
                  view_venta_comprobante_download_zip: `${$BASE_REST}/view_venta_comprobante/download_zip`,
                  view_venta_comprobante_sucursales: `${$BASE_REST}/view_venta_comprobante/sucursales`,
                  view_venta_comprobante_empresas: `${$BASE_REST}/view_venta_comprobante/empresas`,
                  view_venta_comprobante_sincronizar_prepare: `${$BASE_REST}/view_venta_comprobante/sincronizar_prepare`,
                  view_venta_comprobante_sincronizar_step: `${$BASE_REST}/view_venta_comprobante/sincronizar_step`
            }
      },
      reservas: {
            pedido_reservas: {
                  view_reserva_pedido: `${$BASE_REST}/view_reserva_pedido`,
                  ver_imagen: `${$BASE_REST}`, // uploads/nombre_jpg o png se lo concatena en pedido-reserva.component.ts
                  reserva_pedidos: `${$BASE_REST}/reserva_pedidos`,
                  autorizar_reserva: `${$BASE_REST}/reserva_pedido/cambio_estado`
            },
            reserva_pedido_reservar: `${$BASE_REST}/reserva_pedido/reservar`
      },
      deudas: {
            por_inquilino: {
                  view_deudor_inquilinos: `${$BASE_REST}/view_deudor_inquilinos`,
                  view_deudor_detalle: `${$BASE_REST}/view_deudor_detalle`,
                  marcar_incobrable: `${$BASE_REST}/clientes`
            },
            por_periodo: {
                  view_deudor_periodos: `${$BASE_REST}/view_deudor_periodos`,
                  view_deudor_complejo: `${$BASE_REST}/view_deudor_complejo`
            },
            incobrables: {
                  view_incobrables: `${$BASE_REST}/view_deudor_inquilinos?filter[incobrable]=1`
            }
      },
      filtros: {
            disponibles: {
                  view_disponibles: `${$BASE_REST}/view_unidad_funcional_estado`
            },
            proximos_a_vencer: {
                  view_proximos_a_vencer: `${$BASE_REST}/view_contrato_activos?filter[proximo_vencer]=1&filter[corresponde_actualizar]=0`
            }
      },
      valor_alquileres: {
            view_valor_alquieres: `${$BASE_REST}/view_alquiler_valor`
      },
      matching: {
            // Ofertas
            mat_oferta: `${$BASE_REST}/mat_ofertas`,
            view_mat_oferta: `${$BASE_REST}/view_mat_oferta`,
            cambio_estado_oferta: `${$BASE_REST}/mat_oferta/cambio_estado`,
            // Demandas
            mat_demanda: `${$BASE_REST}/mat_demandas`,
            view_mat_demanda: `${$BASE_REST}/view_mat_demanda`,
            cambio_estado_demanda: `${$BASE_REST}/mat_demanda/cambio_estado`,
            // Matching
            mat_matching: `${$BASE_REST}/mat_matching`,
            calcular_score: `${$BASE_REST}/mat_matching/calcular_score`,
            get_scoring: `${$BASE_REST}/mat_matching/get_scoring`,
            set_scoring: `${$BASE_REST}/mat_matching/set_scoring`,
            cambio_estado_matching: `${$BASE_REST}/mat_matching/cambio_estado`,
            // Xintel
            sincronizar_xintel: `${$BASE_REST}/xintel/publicar`,
            detalle_xintel: `${$BASE_REST}/xintel/detalle`,
            ubicaciones_xintel: `${$BASE_REST}/xintel/ubicaciones`,
            portales_xintel: `${$BASE_REST}/xintel/portales`,
      },
      dashboard: {
            oferta: `${$BASE_REST}/view_matching_dashboard?filter[idoperacion]=5`,
            view_oferta: `${$BASE_REST}/view_mat_oferta`,
            demanda: `${$BASE_REST}/view_matching_dashboard?filter[idoperacion]=6`,
            view_demanda: `${$BASE_REST}/view_mat_demanda`,
            matching: `${$BASE_REST}/view_matching_dashboard?filter[idoperacion]=7`,
            clientes: `${$BASE_REST}/clientes?pagination=0`,
            localidades: `${$BASE_REST}/view_localidad`,
            inmobiliarias: `${$BASE_REST}/inmobiliaria`,
            newOferta: `${$BASE_REST}/mat_ofertas`,
            newDemanda: `${$BASE_REST}/mat_demandas`,
            newMatching: `${$BASE_REST}/mat_matching`,
            ofertas: {
                  ver_ofertas: `${$BASE_REST}/view_matching_operacion_estado?filter[idtipo]=5`,
                  captaciones_pendientes: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=22`,
                  captaciones_en_proceso: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=23`,
                  captaciones_pendientes_aprobacion: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=24`,
                  propiedades_captadas: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=25`,
                  perdido_captaciones: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=26`,
                  cambio_estado: `${$BASE_REST}/mat_oferta/cambio_estado`,
                  imprimir_autorizacion: `${$BASE_REST}/mat_oferta/imprimir_autorizacion`
            },
            demandas: {
                  ver_demandas: `${$BASE_REST}/view_matching_operacion_estado?filter[idtipo]=6`,
                  oportunidades_demanda: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=27`,
                  demandas_captadas: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=28`,
                  perdido_consultas: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=29`,
                  cambio_estado: `${$BASE_REST}/mat_demanda/cambio_estado`
            },
            matchings: {
                  ver_operaciones: `${$BASE_REST}/view_matching_operacion_estado?filter[idtipo]=7`,
                  operaciones_en_proceso: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=30`,
                  operaciones_con_reserva: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=31`,
                  operaciones_concretadas: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=32`,
                  operaciones_perdidas: `${$BASE_REST}/view_matching_operacion_estado?filter[idestado]=33`,
                  cambio_estado: `${$BASE_REST}/mat_matching/cambio_estado`
            }
      },
      busquedas: {
            view_busquedas: `https://backendrrhh.baueninmobiliaria.com.ar/web/view_rrhhs`,
            busqueda_vista: `https://backendrrhh.baueninmobiliaria.com.ar/web/rrhh/leido`,
            busqueda_destacado: `https://backendrrhh.baueninmobiliaria.com.ar/web/rrhh/destacado`,
            busqueda_llamado: `https://backendrrhh.baueninmobiliaria.com.ar/web/rrhh/llamado`,
            busqueda_observaciones: `https://backendrrhh.baueninmobiliaria.com.ar/web/rrhh/observaciones`,
      },
      select: {
            rrhh: {
                  ubicaciones: `https://backendrrhh.baueninmobiliaria.com.ar/web/configuracions?filter[tipo]=3&filter[activo]=1&sort=orden`,
                  puestos: `https://backendrrhh.baueninmobiliaria.com.ar/web/configuracions?filter[tipo]=2&filter[activo]=1&sort=orden`,
                  medios: `https://backendrrhh.baueninmobiliaria.com.ar/web/configuracions?filter[tipo]=1&filter[activo]=1&sort=orden`
            },
            tipo_operacion: `${$BASE_REST}/com_configuracion?filter[idconfiguraciontipo]=3`
      },
      menu: `${$BASE_REST}/com_menus`,
      usuario: {
            cambiar_empresa: `${$BASE_REST}/usuario/cambiar_empresa`,
            dispositivos: `${$BASE_REST}/usuario_dispositivo`,
            usuario_agentes_activos: `${$BASE_REST}/usuario/agentes_activos`
      },
      compras: {
            egresos: {
                  view_egreso: `${$BASE_REST}/view_egresos`,
                  egreso: `${$BASE_REST}/egresos`,
                  view_forma_pago_egresos: `${$BASE_REST}/view_forma_pago_egresos`,
                  tipos_comprobantes: `${$BASE_REST}/egreso/tipos_comprobantes`,
                  tipos_comprobantes_letras: `${$BASE_REST}/egreso/tipos_comprobantes_letras`,
                  data_afip: `${$BASE_REST}/empresa/data_afip`,
                  proveedores: `${$BASE_REST}/proveedors`,
                  confirmar: `${$BASE_REST}/egreso/confirmar`,
                  cerrar_periodo: `${$BASE_REST}/egreso/cerrar_periodo`,
                  verificar_periodo_cerrado: `${$BASE_REST}/egreso/verificar_periodo_cerrado`
            },
            pagos_egresos: {
                  view_forma_pago_egresos: `${$BASE_REST}/view_forma_pago_egresos`,
                  forma_pago_egreso: `${$BASE_REST}/forma_pago_egresos`,
                  cheques_terceros_cartera: `${$BASE_REST}/cheque_tercero/cartera`
            }
      },
      configuracion: `${$BASE_REST}/com_configuracion`,
};
